import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
/**
 * 新建企业/团队侧边抽屉
 * @author 严俊华
 */
import { BroadcastChannel } from 'broadcast-channel';
import { Button, Drawer, Form, Input, message, Select } from 'antd';
import { useEffect, useState, useRef } from 'react';
//项目组件
import CascaderPosition from './CascaderPosition';
import FileUpload from './FileUpload';
//工具
import { useDictCodeByCodes } from './hooks';
import { isEmpty } from 'lodash-es';
//api
import { editCompany, getAreaList, putCompany, registerCompany, userCompany, } from '@/shared/services/home';
//css
import { Modal } from 'antd';
import styles from './index.module.less';
const emptyObject = {};
export const AddCompanyDrawer = ({ modalType = 'ADD', currCompany = emptyObject, visible = false, headers = {}, onCancel = () => { }, onRefresh = () => { }, }) => {
    const [areaArr, setAreaArr] = useState([]);
    const [addressData, setAddressData] = useState([]);
    const [companyLogo, setCompanyLogo] = useState([]);
    const [loading, setLoading] = useState(false);
    //字典
    const dictsObj = useDictCodeByCodes(['COMP_PROPERTY', 'UIMS_INDUSTRY_TYPE']);
    //表单
    const [formData] = Form.useForm();
    const firstRef = useRef(true);
    /**
     * 上传logo
     * @param fileList
     */
    const handleLogoChange = async (fileList = []) => {
        if (fileList.length) {
            const info = fileList[0];
            if (info.status === 'done') {
                if (info.response) {
                    if (info.response.code == 200) {
                        formData.setFieldsValue({
                            logoFile: {
                                ...info.response.data,
                                url: info.response.data?.fileSrcUrl,
                                busCode: 'uims1010',
                            },
                        });
                    }
                    else {
                        formData.setFieldsValue({
                            logoFile: undefined,
                        });
                        message.error(`${info.name}图片上传失败.`);
                    }
                }
            }
        }
        else {
            formData.setFieldsValue({
                logoFile: undefined,
            });
            formData.validateFields(['logoFile']);
        }
    };
    // 查询省市级联下拉后续城市
    const loadCascaderData = (selectedOptions, cb) => {
        const targetOption = selectedOptions[selectedOptions.length - 1];
        if (targetOption) {
            targetOption.loading = true;
            getAreaList(targetOption.id).then((res) => {
                targetOption.loading = false;
                if (res.code === 200) {
                    if (res.data.length > 0) {
                        targetOption.isLeaf = false;
                        targetOption.children = res.data.map((item) => {
                            item.isLeaf = !item.hasLower;
                            return item;
                        });
                        setAddressData([...addressData]);
                        if (cb) {
                            cb();
                        }
                    }
                }
            });
        }
    };
    const cascaderOnChange = (date) => {
        formData.setFieldsValue({
            addressData: date,
            province: date && date[0] ? date[0] : '',
            city: date && date.length > 1 ? date[1] : '',
            area: date && date.length > 2 ? date[2] : '',
        });
        setAreaArr(date);
    };
    /**
    * 切换企业
    * @param companyId
    */
    const toChangeCompany = async (company) => {
        const res = await putCompany(company);
        const { code } = res;
        if (code === 200) {
            //成功
            window.location.reload();
        }
    };
    /**
     * 获取用户企业
     */
    const fetchUserCompany = async (company) => {
        const res = await userCompany();
        const { code, data } = res;
        if (code === 200) {
            Modal.confirm({
                title: '切换企业',
                content: '新的企业添加成功，是否切换到新的企业？',
                okText: '切换到新的企业',
                cancelText: '停留在当前企业',
                cancelButtonProps: {
                    style: { display: data?.length > 1 ? 'unset' : 'none' },
                },
                onOk: async () => {
                    toChangeCompany(company);
                },
                onCancel: () => { },
            });
        }
    };
    /**
     * 提交
     */
    const handleSubmit = () => {
        formData.validateFields().then(async () => {
            const params = formData.getFieldsValue(true);
            const { name } = params;
            const nameTrim = name?.trim() || '';
            setLoading(true);
            const req = modalType === 'ADD' ? registerCompany : editCompany;
            const res = await req({
                ...params,
                name: nameTrim,
            }, headers);
            setLoading(false);
            new BroadcastChannel('changeNameBc').postMessage({});
            const { code, data } = res;
            if (code === 200) {
                message.success('操作成功');
                if (modalType === 'ADD') {
                    fetchUserCompany(data);
                    onCancel();
                    onRefresh(data);
                }
                else {
                    onCancel();
                    onRefresh(data);
                }
            }
        });
    };
    /**
     * 获取空间字典
     */
    const getAreaDicts = async () => {
        const res = await getAreaList(0);
        const { code } = res;
        if (code === 200) {
            //成功获取
            const newAddressData = res.data.map((item) => {
                item.isLeaf = !item.hasLower;
                return item;
            });
            setAddressData(newAddressData);
        }
    };
    const loadCascaderDataLoop = (codeArr) => {
        addressData.some((item) => {
            if (item.code == codeArr[0]) {
                if (!item.children || item.children.length == 0) {
                    loadCascaderData([item], () => {
                        if (item.children) {
                            item.children.some((child) => {
                                if (child.code == codeArr[1]) {
                                    loadCascaderData([item, child]);
                                }
                            });
                        }
                    });
                }
                else {
                    item.children.some((child) => {
                        if (child.code == codeArr[1] &&
                            (!child.children || child.children.length == 0)) {
                            loadCascaderData([item, child]);
                        }
                    });
                }
            }
        });
    };
    const loadData = async () => {
        const { company = {} } = currCompany;
        if (company.province) {
            setAreaArr([company.province, company.city, company.area].filter(Boolean));
            loadCascaderDataLoop([company.province, company.city, company.area]);
            formData.setFieldsValue({
                addressData: [company.province, company.city, company.area].filter(Boolean),
            });
        }
    };
    useEffect(() => {
        if (visible)
            getAreaDicts();
    }, [visible]);
    useEffect(() => {
        if (visible) {
            if (modalType !== 'ADD') {
                //获取信息
                const { company = {} } = currCompany;
                formData.setFieldsValue(company);
                const { logoFile } = company;
                setCompanyLogo(isEmpty(logoFile) ? [] : [logoFile]);
            }
        }
        else {
            //清除
            formData.resetFields();
            setAreaArr([]);
            setAddressData([]);
            setCompanyLogo([]);
            firstRef.current = true;
        }
    }, [visible, currCompany]);
    useEffect(() => {
        if (visible &&
            !isEmpty(addressData) &&
            !isEmpty(currCompany) &&
            firstRef.current) {
            firstRef.current = false;
            loadData();
        }
    }, [addressData, currCompany]);
    return (_jsx(Drawer, { visible: visible, onClose: onCancel, title: modalType === 'ADD' ? '新建企业' : '编辑企业基本信息', width: "500", footer: _jsxs("div", { className: styles.drawerFooter, children: [_jsx(Button, { className: styles.refuseBtn, onClick: onCancel, children: "\u53D6\u6D88" }), _jsx(Button, { type: "primary", onClick: handleSubmit, loading: loading, children: "\u786E\u5B9A" })] }), children: _jsxs(Form, { layout: "vertical", form: formData, children: [_jsx(Form.Item, { label: "\u4F01\u4E1A\u540D\u79F0", name: "name", rules: [
                        { required: true, message: '企业名称不能为空', whitespace: true },
                    ], children: _jsx(Input, { maxLength: 80, showCount: true, placeholder: "\u8BF7\u8F93\u5165\u4F01\u4E1A\u540D\u79F0", disabled: [1, '1', 3, '3'].includes(currCompany?.company?.certificationStatus) }) }), _jsx(Form.Item, { label: "\u4F01\u4E1Alogo", name: "logoFile", children: _jsxs("div", { children: [_jsx(FileUpload, { canSlice: true, defaultFileList: companyLogo, listType: "picture-card", param: {
                                    bucket: 'uims',
                                    objectPathPre: 'uims1025',
                                }, accept: ".png, .jpg, .bmp", length: 1, size: 10, onChange: handleLogoChange }), _jsx("div", { className: styles.imageFont, children: "\u4EC5\u652F\u6301jpg\u3001bmp\u3001png\u683C\u5F0F\uFF0C\u6587\u4EF6\u5927\u5C0F\u4E0D\u53EF\u8D85\u8FC710MB" })] }) }), _jsx(Form.Item, { style: { marginTop: '20px' }, label: "\u7701/\u5E02/\u533A\u53BF", name: "addressData", children: _jsx(CascaderPosition, { disabled: [1, '1', 3, '3'].includes(currCompany?.company?.certificationStatus), value: areaArr, addressData: addressData, loadCascaderData: loadCascaderData, cascaderOnChange: cascaderOnChange }) }), _jsx(Form.Item, { label: "\u884C\u4E1A\u7C7B\u578B", name: "industry", children: _jsx(Select, { placeholder: "\u8BF7\u9009\u62E9\u884C\u4E1A\u7C7B\u578B", disabled: [1, '1', 3, '3'].includes(currCompany?.company?.certificationStatus), children: dictsObj?.UIMS_INDUSTRY_TYPE?.map((item) => (_jsx(Select.Option, { children: item.name }, item.code))) }) }), _jsx(Form.Item, { label: "\u4F01\u4E1A\u6027\u8D28", name: "companyNature", children: _jsx(Select, { placeholder: "\u8BF7\u9009\u62E9\u4F01\u4E1A\u6027\u8D28", disabled: [1, '1', 3, '3'].includes(currCompany?.company?.certificationStatus), children: dictsObj?.COMP_PROPERTY?.map((item) => (_jsx(Select.Option, { children: item.name }, item.code))) }) }), _jsx(Form.Item, { label: "\u4F01\u4E1A\u7B80\u4ECB", name: "simpleDesc", children: _jsx(Input.TextArea, { placeholder: "\u8BF7\u8F93\u5165\u4F01\u4E1A\u7B80\u4ECB", maxLength: 200, showCount: true, autoSize: { minRows: 4, maxRows: 6 } }) })] }) }));
};
